import { Helmet } from 'react-helmet';
import RoleListResults from 'src/components/role/RoleListResults';
import RoleListToolbar from 'src/components/role/RoleListToolbar';

import {
  Box,
  Container,
} from '@material-ui/core';

const RoleList = () => (
  <>
    <Helmet>
      <title>Quản lý vai trò</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <RoleListToolbar />
        <Box sx={{ pt: 3 }}>
          <RoleListResults />
        </Box>
      </Container>
    </Box>
  </>
);

export default RoleList;
